import User from 'domain/User'
import { computed } from 'mobx'

export default class CurrentUser extends User {
  @computed get needsToUpdateProfile () {
    return [
      this.firstName,
      this.lastName,
      this.email
    ].some(field => !field)
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/CurrentUser.js